module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    ref: "dashboardButton",
    staticClass: "dashboard-button",
    class: _vm.disabled ? 'set-disabled' : '',
    attrs: {
      "title": (_vm.disabled) ? _vm.disabledMessage : null,
      "to": !_vm.disabled && _vm.toName ? {
        name: _vm.toName
      } : null,
      "variant": "outline-info"
    },
    on: {
      "click": _vm.buttonClick
    }
  }, [_c('div', {
    staticClass: "container h-100"
  }, [_c('div', {
    staticClass: "row align-items-center h-100"
  }, [_c('div', {
    staticClass: "col-8 text-left"
  }, [_c('span', {
    staticClass: "dashboard-button-title"
  }, [_vm._v(_vm._s(_vm.buttonTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 h-100 d-flex align-items-center"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "color": "#17a2b8",
      "size": "4rem",
      "thickness": "6px"
    }
  }) : _c('fa-icon', {
    staticClass: "dashboard-button-icon p-1",
    attrs: {
      "icon": _vm.iconName
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3be7c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/DashboardIconButton.vue
// module id = 1301
// module chunks = 1